/**
 * antd Alert error component
 * https://ant.design/components/alert-cn
 *
 * TODO: 待替換成 chakra-ui 的 useToast (./utils/toast)
 */

import i18n from 'i18next';
import { Alert } from 'antd';
import styles from './antdErrorAlert.scss';

function AntdErrorAlert({
  errorMessage = i18n.t('common.serverErrorMessage'),
  fixed = true,
  onCloseFunction = null,
}) {
  return (
    <Alert
      message={errorMessage}
      type="error"
      closable
      banner
      className={fixed ? styles.alert : styles['alert-no-fixed']}
      afterClose={() => (onCloseFunction === null ? '' : onCloseFunction())}
    />
  );
}

export default AntdErrorAlert;
